import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SubmissionFeedback from '../components/rubrics/SubmissionFeedback';

export default function SubmissionFeedbackPage() {
  const { submissionId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 720, margin: '40px auto', padding: '0 16px', fontFamily: 'system-ui, sans-serif' }}>
      <button
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16, background: 'none', border: 'none', cursor: 'pointer', color: '#667eea', fontSize: 14, fontWeight: 600 }}
      >
        ← Back
      </button>
      <SubmissionFeedback
        submissionId={submissionId}
        onClose={() => navigate(-1)}
      />
    </div>
  );
}
